// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3DDhR","buttons":"SendReceipts_buttons__3Tqzt","email":"SendReceipts_email__1Comv","bookApptTitle":"SendReceipts_bookApptTitle__1zNXe"};